<template>
  <div
    class="bb-toolbar"
    :class="{'bb-toolbar_long': icons === 3, 'bb-toolbar_flex-start': isFlexStart}"
  >
    <img :src="iconEdit"
         class="bb-toolbar__img"
         alt="edit"
         :class="{
          'bb-toolbar__img_hide': hideEditButton
         }"
         @click.stop="openEditForm(index, item)"
         v-if="!noEdit"
    />
    <img :src="iconAdd" class="bb-toolbar__img" alt="add"
         :class="{
           'bb-toolbar__img_first': this.type === 'positions'
         }"
         @click.stop="eventBtnAdd(item, $event)"
         v-if="btnAdd"/>
    <img
      v-if="!noDelete"
      class="bb-toolbar__img"
      src="@/assets/images/icon-delete.png"
      alt="delete"
      @click.stop="deleteConfirmOpen()"
    />
    <span
      v-if="isNoUser"
      class="bb-toolbar__icon bb-toolbar__img"
      v-html="NoUserIcon()"
      @click.stop="onClickIcon(item)"
    />

    <transition name="bounce">
      <div class="bb-toolbar-delete"
           :class="{
           'bb-toolbar-delete_no-edit' : noEdit,
           'bb-toolbar-delete_no-delete': displayReason,
           'bb-toolbar-delete_top': top || forSoa}"
           v-if="deleteIndex === index"
           v-click-outside="deleteConfirmClose">
        <template v-if="displayReason">
          <div class="bb-toolbar-delete__text">
            {{displayReason}}
          </div>
        </template>
        <template v-else>
          <span class="bb-toolbar-delete__title">Are you sure?</span>
          <div class="bb-toolbar-delete-buttons-wrapper">
            <button class="bb-toolbar-delete-buttons-wrapper__button bb-button" type="submit"
                    @click.stop="deleteItem(index, item)">Yes
            </button>
            <button class="bb-toolbar-delete-buttons-wrapper__button bb-button" type="submit"
                    @click.stop="deleteConfirmClose()">No
            </button>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import {get, isEmpty} from 'lodash'
import {NoUserIcon} from '../../../constants/icon'
import iconPencil from '@/assets/images/icon-pencil.png'
import iconTransfer from '@/assets/images/icon-transfer.png'
import iconTransferRed from '@/assets/images/icon-transfer-red.png'
import iconTransferGreen from '@/assets/images/icon-transfer-green.png'
import iconAdd from '@/assets/images/icon-add.png'
import iconSettings from '@/assets/images/icon-settings.png'
import iconSave from '@/assets/images/icon-save.png'

export default {
  name: 'Toolbar',
  props: [
    'deleteIndex',
    'noDeleteReasons',
    'forSoa',
    'item',
    'index',
    'top',
    'btnAdd',
    'noEdit',
    'hideEditButton',
    'noDelete',
    'type',
    'icons',
    'isNoUser',
    'isFlexStart'
  ],
  data: () => ({
    NoUserIcon
  }),
  computed: {
    iconEdit () {
      if (this.type === 'funds') return iconTransfer
      if (this.type === 'kpi') {
        const hasEarned = get(this.item, 'earned', 0) > 0
        return hasEarned ? iconTransferGreen : iconTransferRed
      }
      return iconPencil
    },
    displayReason () {
      if (!this.noDeleteReasons) return
      const reason = this.noDeleteReasons.find(({property}) => get(this.item, property, {}))
      return !isEmpty(reason) ? reason.text : ''
    },
    iconAdd () {
      if (this.type === 'kpiInfo') {
        return iconSave
      }
      return !this.type ? iconAdd : iconSettings
    },
    countIcons () {
      return +!this.noEdit + +!this.noDelete + +this.btnAdd
    }
  },
  methods: {
    deleteConfirmOpen () {
      this.$emit('deleteOpen', this.index)
    },
    deleteConfirmClose () {
      this.$emit('deleteClose')
    },
    openEditForm (index, item) {
      if (this.type === 'kpi' && get(this.item, 'earned', 0) <= 0) return
      this.$emit('openEdit', index, item)
    },
    deleteItem (index, item) {
      const {id, _id} = item
      this.$emit('deleteItem', index, id || _id)
    },
    eventBtnAdd (item, e) {
      this.$emit('btnAdd', item, e)
    },
    onClickIcon (item) {
      this.$emit('onClickIcon', item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-toolbar {
    position: relative;
    display: flex;
    justify-content: space-between;
    z-index: 11;
    user-select: none;
    grid-gap: 0 10px;

    &_long {
      width: 83px;
      min-width: 83px;
    }

    &__img {
      border-radius: 50%;
      width: 21px;
      height: 21px;
      cursor: pointer;
      z-index: 1;

      &_center {
        margin: 0 10px;
      }

      &_hide {
        visibility: hidden;
      }

      &_first {
        order: -1;
        margin: 0;
      }
    }

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      background: $color-wild-sand;
    }

    &-delete {
      position: absolute;
      top: 0px;
      right: 25px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: $color-white;
      box-shadow: 0 0 15px rgba($color-black, 0.05);
      border-radius: 5px;
      z-index: 2;
      padding: 14px;
      min-width: 117px;
      max-width: 458px;

      &_top {
        bottom: 0;
        top: auto;
      }

      &_no-edit {
        right: 50px;
      }

      &_no-delete {
        top: 26px;
        right: 0;
        left: 0;
        width: max-content;
      }

      &__title {
        font-size: 14px;
        line-height: 17px;
      }

      &__text {
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
        text-transform: capitalize;
      }

      &-buttons-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &__button {
          margin-top: 13px;
          width: 39px;
          height: 26px;
        }
      }
    }

    &_flex-start {
      justify-content: flex-start;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Toolbar/Toolbar.vue